import { defineMessages } from 'react-intl';

type MessageKeys = 'deepResearchRateLimitWarning' | 'deepResearchRateLimitWarningDescription';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		deepResearchRateLimitWarning: {
			id: 'chat-history.deep-research-rate-limit-warning',
			description:
				'Short warning message shown in the chat when the user has exceeded the deep research rate limit, instructing them to wait before trying again.',
			defaultMessage: 'Please try again in 24 hours.',
		},
		deepResearchRateLimitWarningDescription: {
			id: 'chat-history.deep-research-rate-limit-warning-description',
			description: 'Deep research rate limit warning description',
			defaultMessage:
				'You have exceeded the rate limit for deep research. Please try again in 24 hours.',
		},
	});

export default message;
